import { render, staticRenderFns } from "./control-bar.vue?vue&type=template&id=b23bf130&scoped=true"
import script from "./control-bar.vue?vue&type=script&lang=js"
export * from "./control-bar.vue?vue&type=script&lang=js"
import style0 from "./control-bar.vue?vue&type=style&index=0&id=b23bf130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23bf130",
  null
  
)

export default component.exports